// Central place for each module's theme color, matching the hardcoded header
// color already used on that module's own step-flow page (see e.g.
// src/app/pages/Bathymetry/index.jsx, src/app/pages/MepBay/index.jsx, etc).
// Kept here so the module-selection cards can reuse the same colors without
// duplicating hex values.
export const MODULE_COLORS = {
  shoreline: '#26A69A',
  bathymetry: '#42A5F5',
  csqueeze: '#687537',
  euscoast: '#A83232',
  intermare: '#FDC669',
  mepbay: '#2B6FAC',
  shore_r: '#FF9D00',
  shore_s: '#7952B3',
};
